const MenuIcon = ({ size }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width={size} height={size} x="0" y="0" viewBox="0 0 24 24">
			<g>
				<path fill="currentColor" d="M21 7H8a1 1 0 0 1 0-2h13a1 1 0 0 1 0 2zm1 5a1 1 0 0 0-1-1H3a1 1 0 0 0 0 2h18a1 1 0 0 0 1-1zm0 6a1 1 0 0 0-1-1h-9a1 1 0 0 0 0 2h9a1 1 0 0 0 1-1z" />
			</g>
		</svg>
	)
}

const MenuLeftIcon = ({ size }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width={size} height={size} viewBox="0 0 24 24"  >
			<g>
				<path fill="currentColor" d="M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1zm0 6a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1zm0 6a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1z" />
			</g>
		</svg>

	)
}

const QuestionIcon = ({ size }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width={size} height={size} x="0" y="0" viewBox="0 0 2000 2000" >
			<g>
				<path fill="currentColor" d="M953.2 1383.7c-29.8 0-53.9-24.1-53.9-53.9 0-70.5 10-131.4 29.9-182.6 14.6-38.6 38.3-77.5 70.9-116.8 24-28.6 67-70.4 129.2-125.2 62.2-54.9 102.6-98.6 121.3-131.2s27.9-68.2 27.9-106.8c0-69.9-27.3-131.2-81.8-184.1s-121.4-79.3-200.6-79.3c-76.5 0-140.4 24-191.6 71.9-37.4 35-65.5 84.4-84.1 148.2-12.8 43.8-55.5 71.8-100.8 66.4-57.4-6.8-95.2-63.6-78.8-119.1 25.2-85.3 67.4-154 126.5-206.2 82.1-72.7 190.7-109 325.8-109 143 0 257.1 38.9 342.3 116.8s127.7 172 127.7 282.4c0 63.9-15 122.8-44.9 176.6-29.9 53.9-88.5 119.4-175.6 196.6-58.5 51.9-96.8 90.2-114.8 114.8s-31.3 52.9-39.9 84.8c-6.4 23.7-10.8 58.5-13.2 104.2-1.5 28.8-25.4 51.4-54.2 51.4h-67.3zm-63.9 258c0-56.5 45.8-102.3 102.3-102.3s102.3 45.8 102.3 102.3-45.8 102.3-102.3 102.3-102.3-45.8-102.3-102.3z" />
			</g>
		</svg>
	)
}

const TimeIcon = ({ size }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width={size} height={size} viewBox="0 0 465.2 465.2">
			<g>
				<path fill="currentColor" d="M279.591 423.714a192.461 192.461 0 0 1-11.629 2.52c-10.148 1.887-16.857 11.647-14.98 21.804a18.651 18.651 0 0 0 7.618 11.876 18.64 18.64 0 0 0 14.175 3.099 233.175 233.175 0 0 0 13.854-3.008c10.021-2.494 16.126-12.646 13.626-22.662-2.494-10.025-12.637-16.125-22.664-13.629zM417.887 173.047a18.644 18.644 0 0 0 6.97 9.398c4.684 3.299 10.813 4.409 16.662 2.475 9.806-3.256 15.119-13.83 11.875-23.631a232.327 232.327 0 0 0-4.865-13.314c-3.836-9.59-14.714-14.259-24.309-10.423-9.585 3.834-14.256 14.715-10.417 24.308a194.816 194.816 0 0 1 4.084 11.187zM340.36 397.013a195.86 195.86 0 0 1-10.134 6.261c-8.949 5.162-12.014 16.601-6.854 25.546a18.664 18.664 0 0 0 5.416 5.942c5.769 4.059 13.604 4.667 20.127.909a233.049 233.049 0 0 0 12.062-7.452c8.614-5.691 10.985-17.294 5.291-25.912-5.693-8.621-17.291-10.989-25.908-5.294zM465.022 225.279c-.407-10.322-9.101-18.356-19.426-17.953-10.312.407-18.352 9.104-17.947 19.422.155 3.945.195 7.949.104 11.89-.145 6.473 3.021 12.243 7.941 15.711a18.647 18.647 0 0 0 10.345 3.401c10.322.229 18.876-7.958 19.105-18.285.103-4.709.064-9.48-.122-14.186zM414.835 347.816c-8.277-6.21-19.987-4.524-26.186 3.738a195.193 195.193 0 0 1-7.434 9.298c-6.69 7.86-5.745 19.666 2.115 26.361.448.38.901.729 1.371 1.057 7.814 5.509 18.674 4.243 24.992-3.171a232.358 232.358 0 0 0 8.874-11.102c6.2-8.262 4.522-19.98-3.732-26.181zM442.325 280.213c-9.855-3.09-20.35 2.396-23.438 12.251a198.06 198.06 0 0 1-3.906 11.253c-3.105 8.156-.13 17.13 6.69 21.939a18.635 18.635 0 0 0 4.126 2.19c9.649 3.682 20.454-1.159 24.132-10.812a240.351 240.351 0 0 0 4.646-13.382c3.085-9.857-2.397-20.349-12.25-23.439zM197.999 426.402a193.1 193.1 0 0 1-47.968-15.244c-.18-.094-.341-.201-.53-.287a204.256 204.256 0 0 1-10.63-5.382c-.012-.014-.034-.023-.053-.031a199.491 199.491 0 0 1-18.606-11.628C32.24 331.86 11.088 209.872 73.062 121.901c13.476-19.122 29.784-35.075 47.965-47.719.224-.156.448-.311.67-.468 64.067-44.144 151.06-47.119 219.089-1.757l-14.611 21.111c-4.062 5.876-1.563 10.158 5.548 9.518l63.467-5.682c7.12-.64 11.378-6.799 9.463-13.675L387.61 21.823c-1.908-6.884-6.793-7.708-10.859-1.833l-14.645 21.161C312.182 7.638 252.303-5.141 192.87 5.165a235.263 235.263 0 0 0-17.709 3.78c-.045.008-.081.013-.117.021-.225.055-.453.128-.672.189-51.25 13.161-95.965 43.052-127.872 85.7-.269.319-.546.631-.8.978a220.276 220.276 0 0 0-3.145 4.353 229.217 229.217 0 0 0-4.938 7.308c-.199.296-.351.597-.525.896C10.762 149.191-1.938 196.361.24 244.383c.005.158-.004.317 0 .479a227.87 227.87 0 0 0 1.088 14.129c.027.302.094.588.145.89a230.909 230.909 0 0 0 1.998 14.145c8.344 48.138 31.052 91.455 65.079 125.16.079.079.161.165.241.247.028.031.059.047.086.076a235.637 235.637 0 0 0 29.793 24.898c28.02 19.744 59.221 32.795 92.729 38.808 10.167 1.827 19.879-4.941 21.703-15.103 1.823-10.169-4.939-19.889-15.103-21.71z" />
				<path fill="currentColor" d="M221.124 83.198c-8.363 0-15.137 6.78-15.137 15.131v150.747l137.87 71.271a15.042 15.042 0 0 0 6.933 1.69c5.476 0 10.765-2.982 13.454-8.185 3.835-7.426.933-16.549-6.493-20.384L236.244 230.65V98.329c-.001-8.351-6.767-15.131-15.12-15.131z" />
			</g>
		</svg>
	)
}


const UserIcon = ({ size }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width={size} height={size} viewBox="0 0 64 64"  >
			<g>
				<path fill="currentColor" d="M30.06 30.44a12.72 12.72 0 0 0 1.89.1 15.04 15.04 0 0 0 1.99-.1 12.122 12.122 0 0 0 9.37-9.73 23.523 23.523 0 0 0-.35-10.51A8.332 8.332 0 0 0 35.55 4h-7.18a8.343 8.343 0 0 0-7.33 6.2 23.306 23.306 0 0 0-.35 10.52 12.122 12.122 0 0 0 9.37 9.72z" />
				<path fill="currentColor" d="M51.4 34.7 45.44 30a4.237 4.237 0 0 0-5.25.03 13.592 13.592 0 0 1-5.85 2.67 12.399 12.399 0 0 1-2.37.14 11.435 11.435 0 0 1-2.35-.15 13.52 13.52 0 0 1-5.81-2.66 4.237 4.237 0 0 0-5.26-.02l-5.94 4.68a8.034 8.034 0 0 0-3.11 6.39v8.4a8.125 8.125 0 0 0 5.58 7.72A55.018 55.018 0 0 0 32 60a55.018 55.018 0 0 0 16.92-2.8 8.125 8.125 0 0 0 5.58-7.72v-8.4a8.035 8.035 0 0 0-3.1-6.38z" />
			</g>
		</svg>
	)
}


const InfoIcon = ({ size }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width={size} height={size} viewBox="0 0 111.577 111.577">
			<g>
				<path fill="currentColor" d="m78.962 99.536-1.559 6.373c-4.677 1.846-8.413 3.251-11.195 4.217-2.785.969-6.021 1.451-9.708 1.451-5.662 0-10.066-1.387-13.207-4.142-3.141-2.766-4.712-6.271-4.712-10.523 0-1.646.114-3.339.351-5.064.239-1.727.619-3.672 1.139-5.846l5.845-20.688c.52-1.981.962-3.858 1.316-5.633.359-1.764.532-3.387.532-4.848 0-2.642-.547-4.49-1.636-5.529-1.089-1.036-3.167-1.562-6.252-1.562-1.511 0-3.064.242-4.647.71-1.59.47-2.949.924-4.09 1.346l1.563-6.378c3.829-1.559 7.489-2.894 10.99-4.002 3.501-1.111 6.809-1.667 9.938-1.667 5.623 0 9.962 1.359 13.009 4.077 3.047 2.72 4.57 6.246 4.57 10.591 0 .899-.1 2.483-.315 4.747-.21 2.269-.601 4.348-1.171 6.239l-5.82 20.605c-.477 1.655-.906 3.547-1.279 5.676-.385 2.115-.569 3.731-.569 4.815 0 2.736.61 4.604 1.833 5.597 1.232.993 3.354 1.487 6.368 1.487 1.415 0 3.025-.251 4.814-.744 1.784-.493 3.085-.926 3.892-1.305zm1.476-86.506c0 3.59-1.353 6.656-4.072 9.177-2.712 2.53-5.98 3.796-9.803 3.796-3.835 0-7.111-1.266-9.854-3.796-2.738-2.522-4.11-5.587-4.11-9.177 0-3.583 1.372-6.654 4.11-9.207C59.447 1.274 62.729 0 66.563 0c3.822 0 7.091 1.277 9.803 3.823 2.721 2.553 4.072 5.625 4.072 9.207z" />
			</g>
		</svg>
	)
}


const SearchIcon = ({ size }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width={size} height={size} viewBox="0 0 56.966 56.966" >
			<g>
				<path fill="currentColor" d="M55.146 51.887 41.588 37.786A22.926 22.926 0 0 0 46.984 23c0-12.682-10.318-23-23-23s-23 10.318-23 23 10.318 23 23 23c4.761 0 9.298-1.436 13.177-4.162l13.661 14.208c.571.593 1.339.92 2.162.92.779 0 1.518-.297 2.079-.837a3.004 3.004 0 0 0 .083-4.242zM23.984 6c9.374 0 17 7.626 17 17s-7.626 17-17 17-17-7.626-17-17 7.626-17 17-17z" />
			</g>
		</svg>
	)
}

const PlusIcon = ({ size }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width={size} height={size} viewBox="0 0 426.667 426.667" >
			<g>
				<path fill="currentColor" d="M405.332 192H234.668V21.332C234.668 9.559 225.109 0 213.332 0 201.559 0 192 9.559 192 21.332V192H21.332C9.559 192 0 201.559 0 213.332c0 11.777 9.559 21.336 21.332 21.336H192v170.664c0 11.777 9.559 21.336 21.332 21.336 11.777 0 21.336-9.559 21.336-21.336V234.668h170.664c11.777 0 21.336-9.559 21.336-21.336 0-11.773-9.559-21.332-21.336-21.332zm0 0" />
			</g>
		</svg>
	)
}

const SmallPlusIcon = ({ size }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width={size} height={size} viewBox="0 0 512 512">
			<g>
				<path fill="currentColor" d="M256 439.98c-13.81 0-25-11.19-25-25V97.02c0-13.81 11.19-25 25-25s25 11.19 25 25v317.96c0 13.81-11.19 25-25 25z" />

				<path fill="currentColor" d="M414.98 281H97.02c-13.81 0-25-11.19-25-25s11.19-25 25-25h317.96c13.81 0 25 11.19 25 25s-11.19 25-25 25z" />
			</g>
		</svg>
	)
}

const UsersIcon = ({ size }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width={size} height={size} viewBox="0 0 512 512" >
			<g>
				<path fill="currentColor" d="M256.2 167.6h84.5c25.1.1 40.3 15.3 40.4 40.3.1 37.1.2 74.3.1 111.4 0 23.6-16 39.7-39.7 40.1-4 .2-8.1.1-12.1-.2-6.1-.6-8.1 1.5-8 7.8.3 29.7-.6 59.4.4 89 .9 27.5-18.6 44.3-43.2 43.2-16.4-.7-32.9-.1-49.3-.2-22.6-.1-38.6-16.1-38.7-38.8-.1-30.7-.1-61.5-.1-92.2 0-8.6.1-8.6-8.9-8.5-5.5.2-11.1 0-16.6-.4-20.2-2.4-33.9-17.1-34-37.5-.3-31.6-.1-63.2-.1-94.8 0-7.2-.3-14.5 0-21.8.9-21.8 15.9-36.9 37.7-37.2 29.2-.5 58.4-.2 87.6-.2z" />
				<path fill="currentColor" d="M117.4 183.1c-11.6 17.5-8.7 36.4-8.9 54.9-.2 30.7-.1 61.4.1 92.1.2 28.9 17.3 51.6 45.2 59.5 4.9 1.4 6.4 3.3 6.2 8.2-.4 9.8 0 19.6-.2 29.4-.3 17.8-13.5 31.2-31.2 31.6-16 .3-32 .4-48 .1-17.1-.3-30.4-14.5-30.6-32.3-.1-25.6-.2-51.2.1-76.8.1-6.2-1.7-8.3-7.9-7.9-10 .5-20.1 1-28.8-5.7C5.1 329.8.2 321.6.2 311.1c-.2-32.7-.2-65.3 0-97.9.1-16.8 13.1-30.7 29.7-31 27.9-.5 55.9-.1 83.8-.1 1.2.3 2.5.6 3.7 1zM399.2 182h21.5c19.2 0 38.4 0 57.6.1 20.4.1 33.6 13.4 33.7 33.8v92.8c0 19.7-13.1 32.9-32.7 33.4H478c-15.9.2-15.9.2-16 15.8 0 22.4 0 44.8-.1 67.2-.1 21-13 33.8-34 33.9-14.5.1-29 .1-43.5 0-17.3.2-31.6-13.5-32.1-30.8-.3-10.7 0-21.3-.1-32 0-3.4 1.2-4.8 4.5-5.6 31.1-7.7 48.9-30.3 49.1-62.4.1-37.8.5-75.6-.2-113.3-.3-10.7-4.1-21.4-6.4-32.9zM190.5 78.4c0-36.2 29.3-65.5 65.4-65.7 36 0 65.8 29.6 65.7 65.5 0 36.2-29.3 65.6-65.5 65.7s-65.6-29.3-65.6-65.5zM352.2 107.5c.2-30.5 25-55 55.4-54.9h.3c29.5.2 54.2 25.4 54 55.3s-25 54.6-54.8 54.5c-30.3 0-54.9-24.6-54.9-54.9zM104.8 52.8c29.3-.4 54.6 24.4 55 53.8.5 30.2-24.1 55.6-54.2 55.9s-55.3-24-55.5-53.8c-.5-30.4 23.7-55.4 54.1-55.9z" />
			</g>
		</svg>

	)
}

const ListCheckIcon = ({ size }) => {
	return (

		<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width={size} height={size} viewBox="0 0 24 24" >
			<g>
				<path fill="currentColor" d="M4 6a2.982 2.982 0 0 1-2.122-.879L.334 3.747a1 1 0 0 1 1.332-1.494l1.585 1.414a1 1 0 0 0 1.456.04L8.311.276a1 1 0 0 1 1.378 1.448L6.1 5.138A2.964 2.964 0 0 1 4 6zm20-2a1 1 0 0 0-1-1H13a1 1 0 0 0 0 2h10a1 1 0 0 0 1-1zM6.1 13.138l3.589-3.414a1 1 0 1 0-1.378-1.448l-3.6 3.431a1.023 1.023 0 0 1-1.414 0l-1.59-1.585a1 1 0 0 0-1.414 1.414l1.585 1.585a3 3 0 0 0 4.226.017zM24 12a1 1 0 0 0-1-1H13a1 1 0 0 0 0 2h10a1 1 0 0 0 1-1zM6.1 21.138l3.585-3.414a1 1 0 1 0-1.378-1.448l-3.6 3.431a1 1 0 0 1-1.456-.04l-1.585-1.414a1 1 0 0 0-1.332 1.494l1.544 1.374a3 3 0 0 0 4.226.017zM24 20a1 1 0 0 0-1-1H13a1 1 0 0 0 0 2h10a1 1 0 0 0 1-1z" />
			</g>
		</svg>
	)
}

const ArrowUpIcon = ({ size }) => {
	return (

		<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width={size} height={size} viewBox="0 0 24 24">
			<g>
				<path fill="currentColor" d="m11 5.414-5.293 5.293a1 1 0 0 1-1.414-1.414l7-7a.999.999 0 0 1 1.414 0l7 7a1 1 0 0 1-1.414 1.414L13 5.414V21a1 1 0 0 1-2 0z" />
			</g>
		</svg>
	)
}


const CategoryTIcon = ({ size }) => {
	return (

		<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width={size} height={size} viewBox="0 0 179.208 179.208">
			<path fill="currentColor" d="M101.116,192.134a29.408,29.408,0,0,1-20.86-8.641L21.567,124.8a29.475,29.475,0,0,1,0-41.719L83.085,21.567a29.475,29.475,0,0,1,41.719,0l58.69,58.69a29.475,29.475,0,0,1,0,41.72l-61.518,61.518a29.408,29.408,0,0,1-20.86,8.641ZM68.093,60.656V76.781H92.905v75.25H112.28V76.781h24.813V60.656Z" transform="translate(-12.927 -12.927)" />
		</svg>

	)
}


const EyeIcon = ({ size }) => {
	return (

		<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width={size} height={size} viewBox="0 0 488.85 488.85">
			<g>
				<path fill="currentColor" d="M244.425 98.725c-93.4 0-178.1 51.1-240.6 134.1-5.1 6.8-5.1 16.3 0 23.1 62.5 83.1 147.2 134.2 240.6 134.2s178.1-51.1 240.6-134.1c5.1-6.8 5.1-16.3 0-23.1-62.5-83.1-147.2-134.2-240.6-134.2zm6.7 248.3c-62 3.9-113.2-47.2-109.3-109.3 3.2-51.2 44.7-92.7 95.9-95.9 62-3.9 113.2 47.2 109.3 109.3-3.3 51.1-44.8 92.6-95.9 95.9zm-3.1-47.4c-33.4 2.1-61-25.4-58.8-58.8 1.7-27.6 24.1-49.9 51.7-51.7 33.4-2.1 61 25.4 58.8 58.8-1.8 27.7-24.2 50-51.7 51.7z" />
			</g>
		</svg>

	)
}


const VotingIcon = ({ size }) => {
	return (

		<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width={size} height={size} viewBox="0 0 24 24">
			<g>
				<path fill="currentColor" d="m20.27 8.12-4.768-4.832c-2.539.861-11.441 1.315-9.409 8.278 0 .021.011.042.011.063H8.8a.582.582 0 0 1 .063-.169 3.263 3.263 0 0 1 2.664-1.649c2.027-.096 2.891 1.498 2.992 1.586a.541.541 0 0 1-.042.677l-.529.529-3.542 3.542c-.465.465-.581 1.184-.275 1.692.433.729 1.512.856 2.104.264l3.256-3.309 1.332-1.353zM21.993 8.13c.357 0 .399-.248 1.565-1.353a.525.525 0 0 0 0-.751C17.503.055 17.733 0 17.31 0a.53.53 0 0 0-.37.159c-1.036 1.103-1.311 1.15-1.311 1.533 0 .309.229.427.359.592.104.062 5.523 5.585 5.624 5.688.106.095.202.126.381.158z" />
				<path fill="currentColor" d="M9.71 15.56s3.01-3.05 3-3.06H2.5c-.28 0-.5.22-.5.5v10.5c0 .28.22.5.5.5h13.02c.27 0 .5-.22.5-.5v-7.9l-3.17 3.22c-.43.43-1.01.67-1.62.67-1.834 0-2.867-2.048-1.836-3.555.09-.128.198-.257.316-.375zm-.315.374z" />
			</g>
		</svg>

	)
}


const SurveyIcon = ({ size }) => {
	return (

		<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width={size} height={size} viewBox="0 0 512 512">
			<g>
				<path fill="currentColor" d="M336 32h-34.752C294.656 13.376 276.864 0 256 0s-38.656 13.376-45.28 32H176c-8.832 0-16 7.168-16 16v64c0 8.832 7.168 16 16 16h160c8.832 0 16-7.168 16-16V48c0-8.832-7.168-16-16-16z" />
				<path fill="currentColor" d="M416 64h-32v48c0 26.464-21.536 48-48 48H176c-26.464 0-48-21.536-48-48V64H96c-17.632 0-32 14.368-32 32v384c0 17.952 14.048 32 32 32h320c17.952 0 32-14.048 32-32V96c0-17.952-14.048-32-32-32zM251.328 347.328l-64 64a16.07 16.07 0 0 1-22.656 0l-32-32c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0L176 377.376l52.672-52.672c6.24-6.24 16.384-6.24 22.624 0s6.272 16.352.032 22.624zm0-128-64 64a16.07 16.07 0 0 1-22.656 0l-32-32c-6.24-6.24-6.24-16.384 0-22.624s16.384-6.24 22.624 0L176 249.376l52.672-52.672c6.24-6.24 16.384-6.24 22.624 0 6.24 6.24 6.272 16.352.032 22.624zM368 384h-64c-8.832 0-16-7.168-16-16s7.168-16 16-16h64c8.832 0 16 7.168 16 16s-7.168 16-16 16zm0-128h-64c-8.832 0-16-7.168-16-16s7.168-16 16-16h64c8.832 0 16 7.168 16 16s-7.168 16-16 16z" />
			</g>
		</svg>


	)
}


const CalendarIcon = ({ size }) => {
	return (

		<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width={size} height={size} viewBox="0 0 24 24" >
			<g>
				<g data-name="Layer 93">
					<path  fill="currentColor" d="M19 5h-1V3a1 1 0 0 0-2 0v2H8V3a1 1 0 0 0-2 0v2H5a3 3 0 0 0-3 3v1h20V8a3 3 0 0 0-3-3zM2 19a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-8H2z" />
				</g>
			</g>
		</svg>


	)
}










const Icon = ({ name, size = 24 }) => {

	const icons = {
		menu: MenuIcon,
		lmenu: MenuLeftIcon,
		question: QuestionIcon,
		time: TimeIcon,
		user: UserIcon,
		info: InfoIcon,
		search: SearchIcon,
		plus: PlusIcon,
		splus: SmallPlusIcon,
		peoples: UsersIcon,
		listCheck: ListCheckIcon,
		arrowUp: ArrowUpIcon,
		iconT: CategoryTIcon,
		eye: EyeIcon,
		vote: VotingIcon,
		survey: SurveyIcon,
		calendar: CalendarIcon,
	}

	const Component = icons[name]
	return <Component size={size} />
}

export {
	Icon
}